// extracted by mini-css-extract-plugin
export default {"gauge-chart-container":"hgh7E","gauge-text":"cC8jV","gauge-progress":"oDh74"};